$(document).ready(function(){
	$("#new_contact_forms_step2 .button-disabled").attr("disabled", true);
	toggle_checkbox_color();
	step2_button_actions(get_selected_companies_length());
	$("#new_contact_forms_step2").on('click', "input[name='contact_forms_step2[company_ids][]']", function() {
		$(this).parent().toggleClass("selected");
		var selected_companies_length = get_selected_companies_length();
		step2_button_actions(selected_companies_length);
		
		if(selected_companies_length > 5){
			alert("最大5社までです。選択数が上限を超えています。");
			$(this).prop('checked', false);
			$(this).parent().removeClass("selected");
			return true;
		}
		update_selected_company_count();
		change_js_text_by_checkbox_value(this.checked, this.value);
	});

	$("#new_contact_forms_step2").on('click', ".container__inner__maker__wrap__content__see-more__button", function() {
		$(this).toggleClass("show-details");
	});

	$(".container__inner__maker__load-more__button").on('click', function() {
		show_more_companies();
	});
	set_checkbox_text();

});

function step2_button_actions(selected_companies_length) {
	var agent_count = parseInt($("#new_contact_forms_step2 .total_company_count").text().replace ( /[^\d.]/g, '' ));
	var contact_forms_step2_button_node = $("#new_contact_forms_step2 .button-disabled");
	if(!isNaN(agent_count) && agent_count > 0 && selected_companies_length > 0){
		contact_forms_step2_button_node.attr("disabled", false).attr("value", "次に進む");
		contact_forms_step2_button_node.addClass("btn-info");
	}else{
		contact_forms_step2_button_node.attr("disabled", true).attr("value", "メーカーを選択して下さい");
		contact_forms_step2_button_node.removeClass("btn-info");
	}
}

function show_more_companies() {
	const url = "/form/step2/show_more_companies";
	$.ajax({ url, type: 'GET' });
}

function get_selected_companies_length() {
	return $("input[name='contact_forms_step2[company_ids][]']:checked").length;
}

window.change_js_text_by_checkbox_value = function(is_checked, company_id) {
	if(is_checked) $("label[for='contact_forms_step2_company_ids_" + company_id + "']").text("選択中");
	else $("label[for='contact_forms_step2_company_ids_" + company_id + "']").text("選択する");
}

window.toggle_checkbox_color = function() {
	$("input[name='contact_forms_step2[company_ids][]']:checked").parent().toggleClass("selected");
}

window.update_selected_company_count = function() {
	var text_location = $(".selected_company_count");
	text_location.text(get_selected_companies_length());
}

window.set_checkbox_text = function() {
	$("input[name='contact_forms_step2[company_ids][]'][type='checkbox']").each(function() {
		change_js_text_by_checkbox_value(this.checked, this.value);
	});
}